import { PIN_DIGITS } from '../../util/securityCredentials'
import PinCodeField, { type PinCellStyle } from './PinCodeField'

type Props = {
	value: string
	onChange: (value: string) => void
	onComplete?: (value: string) => void
	autoFocus?: boolean
	disabled?: boolean
	/** PIN is 4. Email OTP is 6. */
	length?: number
	/** Hide characters (PIN, autofill off). Unmasked = verification code, autofill on. */
	masked?: boolean
	/** Cell look (login screens pass the login palette). */
	cellStyle?: Partial<PinCellStyle>
}

const PinDigitInput = ({
	value,
	onChange,
	onComplete,
	autoFocus,
	disabled,
	length = PIN_DIGITS,
	masked = true,
	cellStyle,
}: Props) => (
	<PinCodeField
		value={value}
		length={length}
		autoFocus={autoFocus}
		disabled={disabled}
		masked={masked}
		codeAutofill={!masked}
		onChange={onChange}
		onComplete={onComplete}
		cellStyle={cellStyle}
	/>
)

export default PinDigitInput
